var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fd567a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.06,
    y: 2.06,
    width: 115.87,
    height: 115.87,
    rx: 21.07,
    ry: 21.07
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.14,34.29c-.59-.5-1.37-.71-2.13-.59l-31.6,5.27c-1.27,.21-2.2,1.31-2.2,2.6v25.17c-1.56-.91-3.34-1.46-5.27-1.46-5.81,0-10.53,4.72-10.53,10.53s4.72,10.53,10.53,10.53,10.53-4.72,10.53-10.53V43.79l26.33-4.39v22.06c-1.56-.91-3.34-1.46-5.27-1.46-5.81,0-10.53,4.72-10.53,10.53s4.72,10.53,10.53,10.53,10.53-4.72,10.53-10.53V36.3c0-.77-.34-1.51-.93-2.01Zm-41.2,46.78c-2.9,0-5.27-2.36-5.27-5.27s2.36-5.27,5.27-5.27,5.27,2.36,5.27,5.27-2.36,5.27-5.27,5.27Zm31.6-5.27c-2.9,0-5.27-2.36-5.27-5.27s2.36-5.27,5.27-5.27,5.27,2.36,5.27,5.27-2.36,5.27-5.27,5.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconAudio);
export default __webpack_public_path__ + "static/media/media-icon-audio.9120cdfe8d816885bde063444164ceb4.svg";
export { ForwardRef as ReactComponent };